// Runtime config - loaded from /config.json at startup
// To change API URLs, just edit config.json on the server. No rebuild needed.

interface RuntimeConfig {
  REACT_APP_API: string;
  REACT_APP_AI_API: string;
}

let _config: RuntimeConfig | null = null;
let _loadPromise: Promise<RuntimeConfig> | null = null;

// Normalize: ensure URL ends with /api
const ensureApi = (url: string): string => url.replace(/\/api\/?$/, '').replace(/\/$/, '') + '/api';

export async function loadConfig(): Promise<RuntimeConfig> {
  if (_config) return _config;
  if (_loadPromise) return _loadPromise;

  _loadPromise = (async () => {
    try {
      const res = await fetch('/config.json?t=' + Date.now());
      if (res.ok) {
        const json = await res.json();
        _config = {
          REACT_APP_API: ensureApi(json.REACT_APP_API || process.env.REACT_APP_API || 'http://localhost:3003/api'),
          REACT_APP_AI_API: ensureApi(json.REACT_APP_AI_API || process.env.REACT_APP_AI_API || 'http://localhost:3003/api'),
        };
        console.log('✅ Runtime config loaded from config.json');
      } else {
        throw new Error('config.json not found');
      }
    } catch {
      // Fallback to build-time env vars
      _config = {
        REACT_APP_API: ensureApi(process.env.REACT_APP_API || 'http://localhost:3003/api'),
        REACT_APP_AI_API: ensureApi(process.env.REACT_APP_AI_API || 'http://localhost:3003/api'),
      };
      console.log('⚠️ Using build-time env vars (config.json not available)');
    }
    console.log('🔧 API_BASE:', _config!.REACT_APP_API);
    console.log('🔧 AI_API_BASE:', _config!.REACT_APP_AI_API);
    return _config!;
  })();

  return _loadPromise;
}

// Sync getter - returns config after loadConfig() has been called.
// If loadConfig() hasn't completed yet, we do a SYNCHRONOUS XHR to fetch
// config.json so we never fall back to stale build-time env vars.
export function getConfig(): RuntimeConfig {
  if (!_config) {
    try {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', '/config.json?t=' + Date.now(), false); // synchronous
      xhr.send();
      if (xhr.status === 200) {
        const json = JSON.parse(xhr.responseText);
        _config = {
          REACT_APP_API: ensureApi(json.REACT_APP_API || 'http://localhost:3003/api'),
          REACT_APP_AI_API: ensureApi(json.REACT_APP_AI_API || 'http://localhost:3003/api'),
        };
        console.log('🔧 Config loaded synchronously from config.json');
      }
    } catch {
      // Last resort fallback
    }
  }
  if (!_config) {
    return {
      REACT_APP_API: ensureApi(process.env.REACT_APP_API || 'http://localhost:3003/api'),
      REACT_APP_AI_API: ensureApi(process.env.REACT_APP_AI_API || 'http://localhost:3003/api'),
    };
  }
  return _config;
}
